import React, { useContext, useEffect, useState } from "react";
import logo from "../assets/image/logo.svg";
import sima from "../assets/image/sima.svg";
import { Link, NavLink } from "react-router-dom";
import { Sling as Hamburger } from "hamburger-react";
import QRCode from "react-qr-code";
import qrlogo from "../assets/image/qrLogo.svg";
import { NumberContext } from "../content/NumberContext";
import slugify from "react-slugify";
import { v4 as uuidv4 } from "uuid";
import axios from "axios";
import { jwtDecode } from "jwt-decode";
import Countdown from "react-countdown";
import translations from "../data/langData";
import { LanguageContext } from "../context/LanguageContext";

const Header = () => {
  const { language, changeLanguage } = useContext(LanguageContext);
  const t = translations[language];

  const handleLanguageChange = (event) => {
    changeLanguage(event.target.value);
  };

  const [user, setUser] = useState(null);
  const [isOpen, setOpen] = useState(false);
  const [mobilePage, setMobilePage] = useState(false);
  const { numbers, loading, error } = useContext(NumberContext);

  const [id, setId] = useState(() => {
    const saved = localStorage.getItem("uuid");
    return saved ? JSON.parse(saved) : uuidv4();
  });

  const [status, setStatus] = useState(0);
  const [qrLink, setQrLink] = useState("");
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    localStorage.setItem("uuid", JSON.stringify(id));
  }, [id]);

  useEffect(() => {
    const checkIfMobile = () => {
      const userAgent = navigator.userAgent || navigator.vendor || window.opera;
      setIsMobile(/android/i.test(userAgent) || /iPad|iPhone|iPod/.test(userAgent));
    };

    checkIfMobile();

    const handleScan = async (operId) => {
      try {
        const response = await axios.post("https://mynumber.az/simaa/qrcode.php", {
          operationId: operId,
        });
        setQrLink(response.data.qrUrl);
      } catch (error) {
        console.log("XETA BAS VERDI :", error);
      }
    };

    handleScan(id);

    const fetchStatus = async () => {
      try {
        const response = await axios.post("https://mynumber.az/simaa/statusAuth.php", {
          operationId: id,
        });
        setStatus(response.data.status);
      } catch (error) {
        console.log("APIDE XETA :", error);
      }
    };

    fetchStatus();
    const intervalId = setInterval(fetchStatus, 5000);

    if (status === 1) {
      const fetchUser = async () => {
        try {
          if (localStorage.getItem("user")) return;

          const response = await axios.post("https://mynumber.az/simaa/userInfo.php", {
            operationId: id,
          });

          localStorage.setItem("user", JSON.stringify(response.data.jwt));
          localStorage.setItem("log", JSON.stringify(1));
          window.location.reload();
        } catch (error) {
          console.error("Xeta burdadir", error);
        }
      };

      fetchUser();
    } else {
      localStorage.setItem("log", JSON.stringify(0));
    }

    return () => clearInterval(intervalId);
  }, [status, id]);

  useEffect(() => {
    const userLS = localStorage.getItem("user");
    if (userLS) {
      const decodedUser = jwtDecode(JSON.parse(userLS));
      setUser(decodedUser.data[0]);
    } else {
      setUser(null);
    }
  }, []);

  const logOut = () => {
    localStorage.removeItem("user");
    localStorage.removeItem("uuid");
    localStorage.setItem("log", JSON.stringify(0));
    window.location.reload();
  };

  const SimaModals = () => (
    <>
      <div
        className="modal fade"
        id="exampleModalToggle"
        aria-hidden="true"
        aria-labelledby="exampleModalToggleLabel"
        tabIndex={-1}
      >
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-header">
              <h1 className="modal-title fs-5" id="exampleModalToggleLabel">
                {t.signIn || "Daxil ol"}
              </h1>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              />
            </div>
            <div
              className="modal-body btn1"
              data-bs-target="#exampleModalToggle2"
              data-bs-toggle="modal"
              style={{ cursor: "pointer" }}
            >
              <img src={sima} alt="" className="img-fluid" />
              <span className="ms-2"> {t.simaTitle || "SİMA Rəqəmsal İmza ilə"} </span>
            </div>
          </div>
        </div>
      </div>

      <div
        className="modal fade"
        id="exampleModalToggle2"
        aria-hidden="true"
        aria-labelledby="exampleModalToggleLabel2"
        tabIndex={-1}
      >
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-header">
              <h1 className="modal-title fs-5" id="exampleModalToggleLabel2">
                <img src={sima} alt="" className="img-fluid" />
                <br />
              </h1>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              />
            </div>
            <div className="modal-body1 simaModal">
              <div className="d-flex justify-content-center align-items-center flex-column my-3">
                {qrLink && <QRCode value={qrLink} size={200} />}
                {isMobile && qrLink && (
                  <div className="sima-btn mt-3">
                    <Link to={`sima://web-to-app?data=${qrLink}`}>
                      SİMA tətbiqinə keçid et
                    </Link>
                  </div>
                )}
                <div className="mt-3">
                  <Countdown
                    overtime={true}
                    date={Date.now() + 1000 * 60 * 5}
                    onComplete={() => setId(uuidv4())}
                    renderer={({ minutes, seconds }) => (
                      <div>
                        <span className="countdown">
                          {t.finishTime || "Bitmə vaxtı:"} {minutes}
                        </span>
                        :<span>{seconds < 10 ? `0${seconds}` : seconds}</span>
                      </div>
                    )}
                  />
                </div>
              </div>
            </div>
            <div className="simaModal">
              <div className="my-3">
                <div className="d-flex align-items-center">
                  <div className="circle"></div>
                  <span className="ms-2" style={{ fontSize: "12px", fontWeight: "bold" }}>
                    {t.simaTitle1 || "SİMA mobil tətbiqini açın."}
                  </span>
                </div>
                <div className="d-flex align-items-center my-2">
                  <div className="circle"></div>
                  <span className="ms-2" style={{ fontSize: "12px", fontWeight: "bold" }}>
                    {t.simaTitle2 || "Skan et düyməsini"}{" "}
                    <img src={qrlogo} alt="" className="img-fluid mx-1" />{" "}
                    {t.simaTitle21 || "sıxın."}
                  </span>
                </div>
                <div className="d-flex align-items-center">
                  <div className="circle"></div>
                  <span className="ms-2" style={{ fontSize: "12px", fontWeight: "bold" }}>
                    {t.simaTitle3 || "QR kodu skan edərək daxil olun."}
                  </span>
                </div>
              </div>
            </div>
            <div className="simaModal">
              <div>
                <div className="d-flex align-items-center">
                  <QRCode
                    value="https://play.google.com/store/apps/details?id=az.dpc.sima&hl=tr"
                    size={200}
                  />
                  <p className="ms-3 mb-0">
                    {t.simaTitle4 || "Sima mobil tətbiqiniz yoxdur?"}
                    <br />
                    <span className="text-secondary" style={{ fontSize: "small" }}>
                      {t.simaDesc || "Hesabınız yoxdursa, mobil telefonunuzla QR kodu skan edərək tətbiqi yükləyib hesab yarada bilərsiniz"}
                    </span>
                  </p>
                </div>
              </div>
            </div>
            <div className="modal-footer">
              <button
                className="btn"
                data-bs-target="#exampleModalToggle"
                data-bs-toggle="modal"
              >
                <i className="fa-solid fa-arrow-left"></i> {t.back || "Geri"}
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );

  return (
    <>
      <section className="header">
        <div className="d-flex justify-content-between align-items-center p-2 px-4">
          <div className="logo">
            <Link to="/" id="noActive">
              <img src={logo} alt="MyNumber Logo" className="img-fluid" />
            </Link>
          </div>
          
          <div className="d-flex align-items-center">
            <NavLink to="/personal" className="mx-3" activeClassName="active">
              Fərdi
            </NavLink>

            <NavLink to="/business" className="mx-3" activeClassName="active">
              Biznes üçün
            </NavLink>

            <div className="menu-item" style={{ zIndex: "99" }}>
              <Link to="#">{t.numbers}</Link>
              <ul className="submenu">
                <NavLink to={`/${slugify(`${1}-classic`)}`}>
                  <li style={{ borderBottom: "1px solid #E4E4E4" }}>Classic</li>
                </NavLink>
                <NavLink to={`/${slugify(`${2}-silver`)}`}>
                  <li style={{ borderBottom: "1px solid #E4E4E4" }}>Silver</li>
                </NavLink>
                <NavLink to={`/${slugify(`${3}-gold`)}`}>
                  <li style={{ borderBottom: "1px solid #E4E4E4" }}>Gold</li>
                </NavLink>
                <NavLink to={`/${slugify(`${4}-platinium`)}`}>
                  <li style={{ borderBottom: "1px solid #E4E4E4" }}>Platinium</li>
                </NavLink>
              </ul>
            </div>

            <NavLink to="/top-up" className="mx-3" activeClassName="active">
              {t.topUp}
            </NavLink>
            
            <Link to="/about" className="me-2">
              {t.about}
            </Link>

            <a href="tel:*8989" className="mx-3 text-dark fw-bold text-decoration-none d-flex align-items-center">
              <i className="fa-solid fa-phone me-1 text-primary"></i> *8989
            </a>

            <select
              id="headerSelect"
              className="ms-2"
              style={{ padding: "0.2rem 1rem", border: "1px solid #ddd", borderRadius: "5px" }}
              value={language}
              onChange={handleLanguageChange}
            >
              <option value="az">AZ</option>
              <option value="en">EN</option>
              <option value="ru">RU</option>
            </select>

            <div className="sima ms-3">
              {!user ? (
                <button
                  data-bs-target="#exampleModalToggle"
                  data-bs-toggle="modal"
                  style={{
                    background: "transparent",
                    border: "1px solid grey",
                    borderRadius: "10px",
                    padding: "5px 10px"
                  }}
                >
                  <img src={sima} alt="Sima Login" className="img-fluid" />
                </button>
              ) : (
                <div className="d-flex align-items-center">
                  <button className="btn fs-6">{user.name}</button>
                  <i
                    className="fa-solid fa-arrow-right-from-bracket text-danger ms-2"
                    style={{ cursor: "pointer" }}
                    onClick={logOut}
                    title="Çıxış"
                  ></i>
                </div>
              )}
            </div>

            <div className="hamburgerIcon ms-2">
              <Hamburger toggled={isOpen} toggle={setOpen} color="#2abee7" />
            </div>
          </div>
        </div>
      </section>

      <div className={`canvas ${isOpen ? "activeCanvas" : ""}`}>
        <div className="d-flex justify-content-between align-items-center p-3">
          <Link to="/" onClick={() => setOpen(false)}>
            <img src={logo} alt="MyNumber Logo" className="img-fluid" />
          </Link>
          <i className="fa-solid fa-xmark fs-3" style={{cursor: "pointer"}} onClick={() => setOpen(false)}></i>
        </div>
        
        <ul>
          <li onClick={() => setMobilePage(!mobilePage)} style={{ cursor: "pointer" }}>
            <div className="d-flex justify-content-between align-items-center">
              {t.numbers}
              <i
                className={`fa-solid fa-chevron-${mobilePage ? "up" : "down"} me-3`}
                style={{ color: "#30D3FF" }}
              ></i>
            </div>
            <ul className={`${mobilePage ? "d-block" : "d-none"}`}>
              <NavLink to={`/${slugify(`${1}-classic`)}`} onClick={() => setOpen(false)}>
                <li style={{ borderBottom: "1px solid #E4E4E4" }}>Classic</li>
              </NavLink>
              <NavLink to={`/${slugify(`${2}-silver`)}`} onClick={() => setOpen(false)}>
                <li style={{ borderBottom: "1px solid #E4E4E4" }}>Silver</li>
              </NavLink>
              <NavLink to={`/${slugify(`${3}-gold`)}`} onClick={() => setOpen(false)}>
                <li style={{ borderBottom: "1px solid #E4E4E4" }}>Gold</li>
              </NavLink>
              <NavLink to={`/${slugify(`${4}-platinium`)}`} onClick={() => setOpen(false)}>
                <li style={{ borderBottom: "1px solid #E4E4E4" }}>Platinium</li>
              </NavLink>
            </ul>
            <hr className="me-3" />
          </li>
          
          <li>
            <NavLink to="/personal" className="me-3" activeClassName="active" onClick={() => setOpen(false)}>
              Fərdi
            </NavLink>
            <hr className="me-3" />
          </li>
          
          <li>
            <NavLink to="/business" className="me-3" activeClassName="active" onClick={() => setOpen(false)}>
              Biznes üçün
            </NavLink>
            <hr className="me-3" />
          </li>
          
          <li>
            <NavLink to="/top-up" activeClassName="active" onClick={() => setOpen(false)}>
              {t.topUp}
            </NavLink>
            <hr className="me-3" />
          </li>
          
          <li>
            <NavLink to="/about" activeClassName="active" onClick={() => setOpen(false)}>
              {t.about}
            </NavLink>
            <hr className="me-3" />
          </li>
        </ul>

        <div className="mx-3 mt-4 mb-4">
          <div className="d-flex flex-column gap-3">
             <a href="tel:*8989" className="text-dark fw-bold text-decoration-none d-flex align-items-center">
              <i className="fa-solid fa-phone me-2 text-primary"></i> *8989
            </a>

            <select
              id="headerSelect"
              value={language}
              onChange={handleLanguageChange}
              style={{ width: "fit-content", padding: "0.2rem 1rem", border: "1px solid #ddd", borderRadius: "5px" }}
            >
              <option value="az">AZ</option>
              <option value="en">EN</option>
              <option value="ru">RU</option>
            </select>

            <div className="sima mt-2">
              {!user ? (
                <button
                  className="btn w-100"
                  style={{ background: "#2abee7", color: "#fff" }}
                  data-bs-target="#exampleModalToggle"
                  data-bs-toggle="modal"
                  onClick={() => setOpen(false)}
                >
                  {t.signIn || "Daxil ol"}
                </button>
              ) : (
                <div className="d-flex align-items-center justify-content-between p-2 border rounded">
                  <span className="fs-6 fw-bold text-primary">{user.name}</span>
                  <button className="btn btn-link p-0 m-0 text-danger" onClick={logOut} title="Çıxış">
                    <i className="fa-solid fa-arrow-right-from-bracket fs-5"></i>
                  </button>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>

      {(!user) && <SimaModals />}
    </>
  );
};

export default Header;
